export function Badge({ children, variant = 'default', className = '' }) {
    const variants = {
      default: 'bg-gray-200 text-gray-800',
      outline: 'border border-gray-300 text-gray-700 bg-white',
      secondary: 'bg-indigo-100 text-indigo-800',
    }
  
    return (
      <span className={`text-xs font-medium px-2 py-1 rounded ${variants[variant]} ${className}`}>
        {children}
      </span>
    )
  }
  